import { fetcher } from '@commenda/utils';
import { RootfiSyncActionResponse } from './types';

export interface CancelSyncRequest {
  rootfi_company_id: number;
  rootfi_organisation_id: number;
  sync_id: string;
}

export async function cancelSync(
  body: CancelSyncRequest
): Promise<{
  success: boolean;
  data?: RootfiSyncActionResponse;
  error?: unknown;
}> {
  try {
    const response = await fetcher(`rootfi/syncs/${body.sync_id}/cancel`, {
      method: 'POST',
      body: {
        rootfi_company_id: body.rootfi_company_id,
        rootfi_organisation_id: body.rootfi_organisation_id,
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error('Error cancelling sync:', errorData);
      return {
        success: false,
        error: errorData.message || 'Failed to cancel sync',
      };
    }

    const data = await response.json();
    return {
      success: true,
      data,
    };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to cancel sync';
    console.error('Failed to cancel sync:', error);
    return {
      success: false,
      error: errorMessage,
    };
  }
}

